// Imports => Constants
import { ENDPOINTS } from '@constants';

export class ComplianceRequirementApi {
  constructor(Client, NoBaseClient, config) {
    this.Client = Client;
    this.NoBaseClient = NoBaseClient;
    this.config = config;
  }

  list_compliance_requirements = (params) => {
    return this.Client.get(`${ENDPOINTS.COMPLIANCE_REQUIREMENTS.LIST}`, { params }).then(
      (response) => response.data.data
    );
  };
}

export default ComplianceRequirementApi;
